<template>
  <div class="diversity-report-wrap">
      <div class="analystics-topbar-wrap">
    <v-row class="analytics-top-bar">
      <v-col cols="1">
        <div class="analytics-title-wrap">
          <div class="analytics-back-btn">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  v-bind="attrs"
                  v-on="on"
                  text
                  @click="onClickBack()"
                >
                  <v-icon>las la-arrow-left</v-icon></v-btn>
              </template>
              <span>Go Back</span>
            </v-tooltip>
          </div>
        </div>
      </v-col>
      <v-col cols="4">
        <div class="analytics-title-wrap">
          <div class="analytics-title">
            <v-select
              class="report-select"
              :items="items"
              hide-details
              flat
              dense
              v-model="analyticsType"
            ></v-select>
          </div>
          <!-- <div class="analytics-title" v-else>--</div> -->
        </div>
      </v-col>
      <v-col class="col-5"></v-col>
      <v-col cols="2" class="pr-4">
        <v-btn
          color="white"
          style=""
          class="box-container zoom-in"
          to="/analytics/custom-report/create"
        >
          <i class="las la-plus mr-1"></i>
          <span>Create new</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
    <!-- <DiversityTopBar
      ref="rateTopBar"
      @toggleReportFilter="toggleReportFilter"
      @resetReportFilters="resetReportFilters"
      @reportDateFilters="reportDateFilters"
    ></DiversityTopBar> -->
    <v-row class="diversity-report-heading mx-4">
      <v-col cols="8">
        <div class="diversity-report-title">
          Custom report
        </div>
        <div class="diversity-report-sub">
          You can create your custom report
        </div>
      </v-col>
    </v-row>
    <v-row style="margin:0 15px;border-radius: 6px;" v-if="customReportSocket.show" :class="customReportSocket.actionStatus ? 'primary' : 'success'">
      <!-- <div class="bulk-status" > -->
        <v-col class="col-1  text-center">
          <v-btn v-if="customReportSocket.actionStatus" :loading="true" color="#fff" text class="mt-2"></v-btn>
          <v-icon style="color:white;" v-if="!customReportSocket.actionStatus" small class="bulk-status-check">
            fas fa-check
          </v-icon>
        </v-col>
        <v-col class="col-10">
          <div style="color:white;" v-if="customReportSocket.actionStatus">
            Your report ({{customReportSocket.report_name}}) has been downloading. Please wait...
          </div>
          <div style="color:white;" v-if="!customReportSocket.actionStatus">
            Your report ({{customReportSocket.report_name}}) has been downloaded successfully.
          </div>
        </v-col>
        <v-col class="col-1 text-center">
          <v-icon style="color:white;" small class="bulk-status-close" @click="customReportSocketClose()">
            fas fa-times
          </v-icon>
        </v-col>
      <!-- </div> -->
    </v-row>
    <div class="report-container">
      <div class="report-wrap">
        <div v-if="customReport.length === 0">
          <p class="w-100 text-center pa-4" style="margin-top:10%;">No custom report available.</p>
        </div>
        <div class="bar-wrap" v-if="customReport.length > 0">
            <v-data-table
                :headers="headers"
                :items="customReport"
                :items-per-page="10"
                class="elevation-1"
            >
              <template slot="headers" slot-scope="props">
                <tr style="border-color:#f3f1f1">
                  <!-- <th class="text-left" v-if="showCheckBoxes">
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      :value="allSelected ? true : false"
                      @change="toggleAll($event)"
                    ></v-checkbox>
                  </th>-->
                  <th class="text-left"
                    v-for="header in props.headers"
                    :key="header.text"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="(item, idx) in items"
                    :key="idx"
                    style="border-color:#f3f1f1"
                  >
                    <!-- <td class="text-left" v-if="showCheckBoxes">
                      <v-checkbox color="primary"
                        @change="updateSelectedAudience(props.item, $event)"
                        :value="selectedAudience[props.index] || allSelected ? true : false"
                        primary
                        hide-details
                        :checked-value="true"
                        :unchecked-value="false">
                      </v-checkbox>
                    </td>-->
                    <td class="text-left">
                      <div class="d-flex flex-row flex-wrap align-center">
                        <!--<v-flex class="py-2" sm3>
                          <v-avatar size="30px" :color="getColor(props.item)">
                            <img src="src" alt="alt" v-show="false">
                            <span class="white--text">{{getAvatar(props.item)}}</span>
                          </v-avatar>
                        </v-flex>-->
                        <v-flex>
                          <p class="mb-0" v-show="item.report_title">
                            <strong :class="'hover-link cursor-pointer'">
                              {{item.report_title}}
                            </strong>
                          </p>
                          <!--<small>
                            {{props.item.email || props.item.user_email}}
                          </small>-->
                        </v-flex>
                      </div>
                    </td>

                    <td class="text-left" v-show="item.report_source">
                      {{item.report_source}}
                    </td>
                    <td class="text-left" v-show="!item.report_source">
                      --
                    </td>

                    <td class="text-left" v-show="item.created_at">
                      {{dayjs(item.created_at).format('DD-MM-YYYY')}}
                    </td>
                    <td class="text-left" v-if="item.report_frequency">
                      {{item.report_frequency}}
                    </td>
                    <td class="text-left" v-if="!item.report_frequency">
                      --
                    </td>

                    <td class="text-left">
                        <v-btn @click="editReport(item.id)" icon><i class="las la-edit"></i></v-btn>
                        <v-btn @click="downloadReport(item, item.id)" icon><i class="las la-download"></i></v-btn>
                        <v-btn @click="deleteReport(item.id)" icon><i class="las la-trash"></i></v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>

              <v-card slot="no-data" class="elevation-0 text-center" min-height="60vh">
                <v-card-title primary-title class="justify-center">
                  <div class="d-flex flex-row flex-wrap">
                    <v-flex xs12>
                        <p>
                          No employees present.
                        </p>
                    </v-flex>
                  </div>
                </v-card-title>
              </v-card>
            </v-data-table>
            <!-- <div class="right-side">
            <div class="right d-flex align-center" v-if="totalCount && totalCount > 0">
              <div class="pre-icon cursor-pointer mr-3 pt-1" @click="displayPre()">
                <i class="las la-chevron-circle-left"></i>
              </div>
              <div>{{getPreNumber}} - {{getNextNumber}} of {{totalCount}}</div>
              <div class="next-icon cursor-pointer ml-3 pt-1" @click="displayNext()">
                <i class="las la-chevron-circle-right"></i>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="reportFilterDrawer">
      <!-- <reportFilters
        ref="ReportFilters"
        reportType="gender_diversity"
        @dashFiltersApplied="dashFiltersApplied"
      ></reportFilters> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import { format, subDays } from 'date-fns';
import relativeTime from 'dayjs/plugin/relativeTime';
import AnalyticsMixin from './analytics-mixin';

dayjs.extend(relativeTime);
export default {
  name: 'DiversityReport',

  mixins: [AnalyticsMixin],

  components: {
    // DiversityTopBar,
    // ReportFilters,
    // AnalyticsTopbar,
    // DiversityOvertimeStats,
    // DiversitySortByNav,
    // DiversityOvertimeBar,
    // DiversityDriverStats,
    // DiversityOvertimeTable,
    // DiversityDriverBar,
    // DiversityDriverDonught,
    // DiversityDriverTable
  },

  data () {
    return {
      pagination: {
        itemsPerPage: 10,
        itemsLength: 15
      },
      customReportSocket: {
        show: false,
        report_name: '',
        actionStatus: true,
        error: false
      },
      isFilterApplied: false,
      items: [
        'Employee lifecycle',
        'Employee participation rate',
        'Chat response rate',
        'Gender-wise engagement analysis',
        'Custom report',
        'Group wise engagement metrics',
        'Age group wise engagement analysis'
      ],
      analyticsType: 'Custom report',
      headers: [{
        text: 'Report title',
        sortable: false
      }, {
        text: 'Source',
        sortable: false
      }, {
        text: 'Created on',
        sortable: false
      }, {
        text: 'Frequency',
        sortable: false
      }, {
        text: 'Action',
        sortable: false
      }],
      customReport: null,
      // sortByData: [],
      // sortOptions: {
      //   location: 'Location',
      //   site: 'Site',
      //   department: 'Department',
      //   gender: 'Gender',
      //   business: 'Business',
      //   grade: 'Grade',
      //   hrbp: 'HR Business Partner',
      //   hr_manager: 'HR Manager',
      //   cluster: 'Cluster',
      // },
      filterOptions: {},
      chartData: {
        default: [],
        selected: []
      },
      sortByKey: '',
      selectedfilters: [],
      reportDate: {
        start: format(subDays(new Date(), 365), 'yyyy-MM-dd'),
        end: format(new Date(), 'yyyy-MM-dd')
      },
      trendsData: {
        default: [],
        selected: {}
      },
      overtimeBarData: {},
      overallEngagements: {},
      overallParticipation: {},
      overtimeTableData: {},
      driverBarData: {},
      driverTableData: {},
      reportDates: [],
      reportDrivers: [],
      reportModel: '',
      reportType: '',
      socketResponse: {
        show: false
      },
      page_offset: 0
    };
  },

  computed: {
    ...mapState({
      user: state => state.user
    }),
    getPreNumber () {
      const num = (this.page_offset - 1) * 10 + 1;
      if (num > this.totalCount) {
        return this.totalCount;
      }
      return num;
    },
    getNextNumber () {
      const num = (this.page_offset - 1) * 10 + 10;
      if (num > this.totalCount) {
        return this.totalCount;
      }
      return num;
    }
  },
  created () {
    // this.getSortOptions();
    // this.getDiversityReport();
    // this.$store.dispatch('updateReportFilters', null);
  },
  watch: {
    analyticsType () {
      // console.log('analyticsType -> this.analyticsType', this.analyticsType);
      if (this.analyticsType === 'Employee lifecycle') {
        this.$router.push({ path: '/analytics/life-cycle' }).catch(() => {});
      }
      if (this.analyticsType === 'Employee participation rate') {
        this.$router.push({ path: '/analytics/participation-rate' }).catch(() => {});
      }
      if (this.analyticsType === 'Chat response rate') {
        this.$router.push({ path: '/analytics/response-rate' }).catch(() => {});
      }
      if (this.analyticsType === 'Gender-wise engagement analysis') {
        this.$router.push({ path: '/analytics/diversity-report' }).catch(() => {});
      }
      if (this.analyticsType === 'Custom report') {
        this.$router.push({ path: '/analytics/custom-report' }).catch(() => {});
      }
      if (this.analyticsType === 'Group wise engagement metrics') {
        this.$router.push({ path: '/analytics/group-metrics-report' }).catch(() => {});
      }
      if (this.analyticsType === 'Age group wise engagement analysis') {
        this.$router.push({ path: '/analytics/age-group-report' }).catch(() => {});
      }
    }
  },
  beforeMount () {
    this.getCustomReport();
  },
  methods: {
    customReportSocketClose () {
      this.customReportSocket.show = false;
      this.customReportSocket.report_name = '';
      this.customReportSocket.actionStatus = false;
    },
    onClickBack () {
      this.$router.push({ path: '/analytics' }).catch(() => {});
    },
    downloadReport (item, id) {
      /*eslint-disable*/
      if (item.report_source === 'Employees Overview Data' || item.report_source === 'UserProfile Data') {
        this.reportModel = 'UserProfile';
        this.reportType = 'custom_employees'
      }
      if (item.report_source === 'Employee Responses Data') {
        this.reportModel = 'SessionInteraction';
        this.reportType = 'custom_responses'
      }
      if (item.report_source === 'Employee Chats Data') {
        this.reportModel = 'SessionModel';
        this.reportType = 'custom_chats'
      }
      this.customReportSocket.report_name = item.report_title;
      axios.post(`${process.env.VUE_APP_API_URL}reports/custom_reports/download/?response_type=async`, {
        "report_id": id,
        "model": this.reportModel,
        "response_type":"sync",
        "report_type": this.reportType,
        "report_name": item.report_title,
        "columns": item.report_columns
      }).then((response) => {
        if (response && response.data) {
        this.socketResponse.show = true;
        this.$store.dispatch('updateReportData', this.socketResponse);
        const session = JSON.parse(localStorage.getItem('CHATBOT_USER'));
        const company = session.company.replace(/-/g, '');
        const socket = new WebSocket(`${process.env.VUE_APP_SOCKET_URL}${company}/?verify=${session.access_token}&username=${session.email}`);
        // const tempRes = null;
        socket.addEventListener('message', (res) => {
            this.socketResponse = JSON.parse(res.data);
        });
            this.$forceUpdate();
            
            setTimeout(() => {
              this.$store.dispatch('updateReportData', this.socketResponse);
            }, 10000);
          
        
          
          
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to download report, Please try again later!'
          });
        }
      });
    },
    editReport (id) {
      const queryParams = {
        report: id,
      };
      this.$router.push({
        path: '/analytics/custom-report/edit',
        query: queryParams
      }).catch(() => {});
    },
    deleteReport (id) {
      axios.delete(`${process.env.VUE_APP_API_URL}reports/custom_reports/${id}`).then((response) => {
        if (response) {
          this.$store.dispatch('updateSnackbar', {
            color: 'success',
            show: true,
            text: 'Deleted successfully!'
          });
            this.getCustomReport();
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to delete report, Please try again later!'
          });
        }
      });
    },
    getCustomReport () {
      const queryParams = {
      };
      axios.get(`${process.env.VUE_APP_API_URL}reports/custom_reports`, {
        params: queryParams
      }).then((response) => {
        if (response && response.data) {
          this.customReport = response.data.results;
        }
      }).catch((err) => {
        if (err.response.status === 429) {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: err.response.data.error
          });
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to get report, Please try again later!'
          });
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.diversity-report-wrap {
  .diversity-report-heading {
    margin: 0;
    .diversity-report-title {
      color: var(--color-text);
      // font-size: var(--content-size);
      font-size: var(--stats-size-1);
    }
    .diversity-report-sub {
      color: var(--color-text);
      font-size: var(--content-size);
      padding: 8px 0;
    }
  }
  .report-container {
    background-color: var(--bg);
    // height: 74vh;
    // overflow: hidden;
    // border-radius: 12px;
    margin: 0 12px;
    .report-wrap {
      // margin: 0 20px;
      // padding: 0 20px;
      // height: 70vh;
      // overflow-y: auto;
      // overflow-x: hidden;
      .bar-wrap {
        // display: grid;
        // grid-template-columns: 1fr;
        margin-top: 20px;
        .report-title {
          padding-bottom: 14px;
          color: var(--color-text);
          font-size: var(--heading-size);
          font-weight: var(--heading-weight);
        }
        .report-bar-graph {
          // margin-right: 10px;
          display: grid;
          grid-template-columns: 2fr 5fr;
          height: 450px;
          background: var(--bg);
          box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
          border-radius: 0.5rem;
        }
        .overtime-table {
          background-color: var(--bg);
          box-shadow: 0 4px 16px 11px rgba(0, 0, 0, 0.06),0 4px 8px rgba(0, 0, 0, 0.1) !important;
          margin: 20px 0;
          display: grid;
          grid-template-columns: 1fr;
          // border-radius: 0.5rem;
          overflow: hidden;
          padding: 16px;
        }
        .driver-reports {
          .report-title {
            padding: 16px 0 6px 0;
            color: var(--color-text);
            font-size: var(--heading-size);
            font-weight: var(--heading-weight);
          }
          .driver-bar-graph {
            margin: 20px 0;
            display: grid;
            grid-template-columns: 5fr 4fr;
            // height: 600px;
            background: var(--bg);
            border-radius: 0.5rem;
          }
          .driver-table {
            margin: 20px 0;
            display: grid;
            grid-template-columns: 1fr;
            // border-radius: 0.5rem;
            overflow: hidden;
          }
        }
      }
      .report-trend-graph {
        margin-top: 20px;
        padding: 30px 30px;
        height: 600px;
        background: var(--bg);
        border-radius: 0.5rem;
        .trends-title {
          display: grid;
          place-items: center;
          padding-bottom: 16px;
          margin-top: -16px;
          color: var(--color-text);
          font-size: var(--heading-size);
          font-weight: var(--heading-weight);
        }
      }
    }
    .no-report-data {
      display: grid;
      grid-template-columns: 1fr;
      background-color: var(--bg);
      align-items: center;
      justify-items: center;
      margin: 50px;
      border-radius: 1rem;
      height: 300px;
      .sad-amara {
        text-align: center;
        img {
          width: 25%;
          border-radius: 100%;
        }
      }
      .am-text {
        font-size: var(--heading-size);
        color: var(--color-text);
      }
    }
    .intro-x {
      opacity: 0;
      position: relative;
      transform: translateX(80px);
      animation: 0.6s intro-x-animation ease-in-out 0.33333s;
      animation-fill-mode: forwards;
      animation-delay: 0.3s;
    }
    @keyframes intro-x-animation {
      100% {
        opacity: 1;
        transform: translateX(0px);
      }
    }
  }
}

</style>
<style lang="scss">
.disable-action {
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: var(--bg) !important;
  }
}
.abcd {
    display: none;
  }
.downloadReportBtn:hover {
  .abcd {
    display: block;
  }
}

// .v-select__selection v-select__selection--comma
.analytics-top-bar {
    background: #050550;
    background-image: -webkit-gradient(linear,right top,left top,from(transparent),to(rgba(51,148,255,.18)));
  .report-select {
    .v-select__selection {
      color: var(--bg) !important;
    }
    .v-input__slot {
      .v-input__icon--append {
        .v-icon {
          color: var(--bg) !important;
        }
      }
      &:before {
        border-color: var(--bg) !important;
      }
    }
  }
}
</style>

